module.exports = __webpack_public_path__ + "img/ESCUT_2008.18e29422.jpg";